import React from 'react';
import { useNavigate } from 'react-router-dom';

const BlogTitle = () => {
  const navigate = useNavigate();
  
  const navigateTo = (postId) => {
    switch(postId) {
      case 'sr-as-pilots':
        navigate('/blog/sr-as-pilots');
        break;
      case 'llms-vs-abm':
        navigate('/blog/llms-vs-abm');
        break;
      case 'ai-twin-project':
        navigate('/blog/ai-twin-project');
        break;
      case 'revolutionizing-survey-research':
        navigate('/blog/revolutionizing-survey-research');
        break;
      case 'day-one-benchmark':
        navigate('/blog/day-one-benchmark');
        break;
      case 'ai-new-respondents':
        navigate('/blog/ai-respondeny-value-prop');
        break;
      case 'stanford-generative-agents':
        navigate('/blog/stanford-generative-agents');
        break;
      case 'can-ai-predict-public-opinion':
        navigate('/blog/can-ai-predict-public-opinion');
        break;
      case 'anthology-virtual-personas':
        navigate('/blog/anthology-virtual-personas');
        break;
      case 'conversational-survey-builder':
        navigate('/blog/conversational-survey-builder');
        break;
      case 'trust-humans-and-ai':
        navigate('/blog/trust-humans-and-ai');
        break;
      case 'bad-survey-questions':
        navigate('/blog/bad-survey-questions');
        break;
      case 'pollsters-dilemma':
        navigate('/blog/pollsters-dilemma');
        break;
      case 'time-of-day':
        navigate('/blog/time-of-day');
        break;
      case 'weighting-silicon-sample':
        navigate('/blog/weighting-silicon-sample');
        break;
      case 'comprehensive-guide-to-sr':
        navigate('/blog/comprehensive-guide-to-sr');
        break;
      case 'review-of-sr-research':
        navigate('/blog/review-of-sr-research');
        break;
      case 'overview-sr':
        navigate('/blog/overview-sr');
        break;
      default:
        navigate('/blog');
    }
  };

  const posts = [
    {
      id: 'sr-as-pilots',
      title: 'Our New Research Assistant is an AI: Can Synthetic Respondents Really Pilot-Test Surveys?',
      href: '/blog/sr-as-pilots',
      description:
        'A deep dive into whether AI-generated synthetic respondents can effectively replace human pilot testing in survey research, examining the trade-offs between speed, cost, and validity.',
      date: 'Jan 30, 2025',
      datetime: '2025-01-30',
      category: { title: 'Research Methodology', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'llms-vs-abm',
      title: 'Digital Doppelgangers: The AI Showdown for the Most Realistic Consumer Model',
      href: '/blog/llms-vs-abm',
      description:
        'A comprehensive comparison between Fine-Tuned Large Language Models and Agent-Based Models for consumer behavior simulation, exploring which methodology delivers the most realistic and reliable synthetic respondents.',
      date: 'Jan 30, 2025',
      datetime: '2025-01-30',
      category: { title: 'AI Research', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'overview-sr',
      title: 'Synthetic Respondents in Market Research: A Complete Guide',
      href: '/blog/overview-sr',
      description:
        'A comprehensive guide to synthetic respondents in market research, covering their definition, benefits, risks, validation frameworks, and practical use cases for researchers and businesses.',
      date: 'Jan 30, 2025',
      datetime: '2025-01-30',
      category: { title: 'Market Research Guide', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'review-of-sr-research',
      title: 'Synthetic Respondents in Computational Social Science: A Historical and Methodological Review',
      href: '/blog/review-of-sr-research',
      description:
        'A comprehensive review of synthetic respondents from early agent-based models to modern LLM-based approaches, examining their evolution, current practices, and future directions in computational social science.',
      date: 'Jan 30, 2025',
      datetime: '2025-01-30',
      category: { title: 'Research Review', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'comprehensive-guide-to-sr',
      title: 'The Comprehensive Guide to Synthetic Respondents',
      href: '/blog/comprehensive-guide-to-sr',
      description:
        'Everything you need to know about AI-generated survey participants in 2025. From technical creation to real-world applications across industries.',
      date: 'Feb 5, 2025',
      datetime: '2025-02-05',
      category: { title: 'Research Deep Dive', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'weighting-silicon-sample',
      title: 'Stop Overweighting and Start Simulating: The Case for Synthetic Data in Political Polling',
      href: '/blog/weighting-silicon-sample',
      description:
        'A deep dive into the controversial but increasingly necessary world of synthetic data in political polling. When traditional weighting fails, is AI-generated data the answer?',
      date: 'Jan 30, 2025',
      datetime: '2025-01-30',
      category: { title: 'Methodology', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'time-of-day',
      title: 'The 3 PM Slump in Your Tracking Poll: Are We Measuring Partisan Anger or Just Bad Timing?',
      href: '/blog/time-of-day',
      description:
        'How the timing of survey administration may be systematically biasing our most sensitive political metrics. A deep dive into the biological rhythms that could be contaminating our data.',
      date: 'Jan 24, 2025',
      datetime: '2025-01-24',
      category: { title: 'Methodology', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'pollsters-dilemma',
      title: 'The Pollster\'s Dilemma: In a World of <5% Response Rates, Is MRP the Only Path Forward for State-Level Accuracy?',
      href: '/blog/pollsters-dilemma',
      description:
        'A deep dive into the methodological crisis facing modern polling and how Multilevel Regression and Post-stratification (MRP) offers a path forward when traditional RDD surveys struggle.',
      date: 'Aug 25, 2025',
      datetime: '2025-08-25',
      category: { title: 'Methodology', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'bad-survey-questions',
      title: 'Garbage In, Catastrophe Out: The Billion-Dollar Blind Spot in Your AI Product Launch',
      href: '/blog/bad-survey-questions',
      description:
        'How flawed survey questions are sabotaging AI products and costing companies millions. A deep dive into the hidden risks of biased research.',
      date: 'Aug 20, 2025',
      datetime: '2025-08-20',
      category: { title: 'AI Strategy', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'trust-humans-and-ai',
      title: 'The Million-Dollar Question: When Do You Trust an AI More Than a Human Panel?',
      href: '/blog/trust-humans-and-ai',
      description:
        'Where AI is already more reliable than panels—and where only humans will do. A practical playbook for hybrid insights.',
      date: 'Aug 14, 2025',
      datetime: '2025-08-14',
      category: { title: 'Thought Leadership', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'conversational-survey-builder',
      title: 'HumanAI Is Re-Imagining Survey Design: A Conversational, AI-First Workspace',
      href: '/blog/conversational-survey-builder',
      description:
        'Our vision for the future of survey design: a fluid conversation with an AI copilot that collapses research craftsmanship and interface wrangling into a single, intuitive experience.',
      date: 'July 20, 2025',
      datetime: '2025-07-20',
      category: { title: 'Product Vision', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'anthology-virtual-personas',
      title: 'From Bullet-Point Bios to Rich Backstories: How “Anthology” Uses Human AI to Make Virtual Personas Feel (and Vote) Real',
      href: '/blog/anthology-virtual-personas',
      description:
        'A new study shows that giving AI models rich life stories instead of demographic bullet points dramatically improves their ability to simulate real human responses.',
      date: 'July 18, 2025',
      datetime: '2025-07-18',
      category: { title: 'Research Deep Dive', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'can-ai-predict-public-opinion',
      title: 'Can AI Predict Public Opinion? A New Study Says Yes—If You Train It Right Inspiring HumanAI',
      href: '/blog/can-ai-predict-public-opinion',
      description:
        'A groundbreaking study from UC Berkeley and Microsoft Research shows that fine-tuning LLMs on real survey data dramatically improves their ability to predict diverse human opinions.',
      date: 'July 14, 2025',
      datetime: '2025-07-14',
      category: { title: 'Research Deep Dive', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'ai-twin-project',
      title: 'The AI Twin Project: Pioneering the Next Generation of Market Research At HumanAI',
      href: '/blog/ai-twin-project',
      description:
        'HumanAI\'s AI Twin Project creates AI agents that accurately reflect real individuals through deep interviews, ongoing validation, and ethical compensation.',
      date: 'July 10, 2025',
      datetime: '2025-07-10',
      category: { title: 'Product Innovation', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'stanford-generative-agents',
      title: 'Generative Agents Inspired HumanAI: How Stanford Simulated 1,000 Real People with AI',
      href: '/blog/stanford-generative-agents',
      description:
        'Stanford researchers built 1,000+ AI "twins" based on deep interviews and tested how well they could predict human responses. The results prove AI agents can serve as stand-ins for real humans.',
      date: 'July 4, 2025',
      datetime: '2025-07-4',
      category: { title: 'Research Deep Dive', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'ai-new-respondents',
      title: 'What If HumanAI Could Cut Research Costs by 90% — and Still Get Human-Quality Insights?',
      href: '/blog/ai-respondeny-value-prop',
      description:
        'At HumanAI Ventures, we\'re building AI respondents that think, feel, and decide like people — without the cost, time, and hassle of traditional research.',
      date: 'May 5, 2025',
      datetime: '2025-05-05',
      category: { title: 'Product Vision', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',  
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'day-one-benchmark',
      title: 'Day One Benchmark From HumanAI: Promising Signals, Big Potential',
      href: '/blog/day-one-benchmark',
      description:
        'Can large language models (LLMs) simulate real human survey respondents? Inspired by Bisbee et al. (2024), I ran an early benchmark to find out.',
      date: 'Apr 20, 2025',
      datetime: '2025-04-20',
      category: { title: 'Technology', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
    {
      id: 'revolutionizing-survey-research',
      title: 'Why HumanAI is Rebuilding the Future of Survey Research',
      href: '/blog/revolutionizing-survey-research',
      description:
        'This is our moonshot: reimagining how the world understands itself, powered by AI.',
      date: 'Apr 12, 2025',
      datetime: '2025-04-12',
      category: { title: 'Vision', href: '#' },
      author: {
        name: 'Sharif Amlani, PhD',
        role: 'Founder & CEO',
        company: 'HumanAI',
        href: '#',
        imageUrl: process.env.PUBLIC_URL + '/img/sharif-headshot.jpg',
      },
    },
  ];

  return (
    <section id="blog-title" className="py-10 bg-black relative mt-4">
      <div className="bg-black py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl lg:mx-0">
            <h2 className="text-4xl font-semibold tracking-tight text-white sm:text-5xl">
              From the <span className="text-white">Human</span>
              <span className="text-pink">AI</span> blog
            </h2>
            <p className="mt-2 text-lg text-gray-400">
              Insights and perspectives on AI-powered survey research
            </p>
          </div>

          <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 border-t border-gray-800 pt-10 sm:mt-16 sm:pt-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">
            {posts.map((post) => (
              <article
                key={post.id}
                className="flex max-w-xl flex-col items-start justify-between group cursor-pointer"
                onClick={() => navigateTo(post.id)}
              >
                <div className="flex items-center gap-x-4 text-xs">
                  <time dateTime={post.datetime} className="text-gray-400">
                    {post.date}
                  </time>
                  <a
                    href={post.category.href}
                    className="relative z-10 rounded-full bg-gray-900 px-3 py-1.5 font-medium text-gray-300 hover:bg-gray-800"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {post.category.title}
                  </a>
                </div>

                <div className="group relative flex flex-col grow w-full">
                  <h3 className="mt-3 text-lg font-semibold text-white transition duration-300 min-h-[3.5rem] group-hover:text-pink">
                    <span className="relative z-10">{post.title}</span>
                  </h3>
                  <p className="mt-4 text-sm text-gray-400">{post.description}</p>
                </div>

                <div className="relative mt-8 flex items-center gap-x-4">
                  <img
                    alt={post.author.name}
                    src={post.author.imageUrl}
                    className="h-10 w-10 rounded-full bg-gray-900"
                  />
                  <div className="text-sm">
                    <p className="font-semibold text-white">
                      <a href={post.author.href}>
                        <span className="absolute inset-0" />
                        {post.author.name}
                      </a>
                    </p>
                    <p className="text-gray-400">{post.author.role}</p>
                    <p className="text-gray-400">{post.author.company}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogTitle;
